import i18n from '@/config/i18n';
import type { SchedulingEnrollment } from '@/types/scheduling';
import { isEnrollmentExpired } from './isEnrollmentExpired';

export const isEnrollmentValid = (
  enrollment: SchedulingEnrollment,
  timeZone: string,
): {
  valid: boolean;
  reason?: string;
} => {
  if (isEnrollmentExpired(enrollment, timeZone)) {
    return { valid: false, reason: i18n.t('isEnrollmentValid.expired') };
  }

  if (enrollment.type === 'FLEXIBLE') {
    return { valid: true };
  }

  if (enrollment.type === 'SESSIONS_PACKAGE' || enrollment.type === 'PRIVATE_SESSIONS_PACKAGE') {
    const packageSessions = enrollment.remainingSessions.packageSessions;
    if (packageSessions && packageSessions.remainingCount > 0) {
      return { valid: true };
    }
    if (!packageSessions) {
      return { valid: false, reason: i18n.t('isEnrollmentValid.general') };
    }
    return { valid: false, reason: i18n.t('isEnrollmentValid.allSessionsBooked', { count: packageSessions.totalCount }) };
  }

  if (enrollment.type === 'MONTHLY_SESSIONS') {
    const monthlySessions = enrollment.remainingSessions.monthlySessions;
    let monthlyRemaining = 0;
    let allUsed = 0;
    if (monthlySessions) {
      for (const month of monthlySessions) {
        allUsed += month.usedCount;
        monthlyRemaining += month.remainingCount;
      }
      if (monthlyRemaining > 0) {
        return { valid: true };
      }
      return { valid: false, reason: i18n.t('isEnrollmentValid.allSessionsBooked', { count: allUsed }) };
    }
    return { valid: false, reason: i18n.t('isEnrollmentValid.general') };
  }

  return { valid: false, reason: i18n.t('isEnrollmentValid.general') };
};
